var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"hover":""}},[_c('v-card-title',[_c('v-icon',{attrs:{"left":""}},[_vm._v("person")])],1),_vm._v("\n  "+_vm._s(_vm.getPrimaryId.value)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }